import filtersDisplayConfig from "./filtersDisplay.config";
import apiPathsConfig from './apiPaths.config';
import LocationsTableListItem from "../LocationsListItem/LocationsTableListItem.vue";
import availableActionsConfig from "./availableActions.config";
import availableListViewsConfig from "./availableListViews.config";

const itemsListerConfig = {
  TableViewItem: LocationsTableListItem,
  apiPathsConfig,
  filtersDisplayConfig,
  availableActionsConfig,
  availableListViewsConfig,
  columnsToHide:[]
}

export default itemsListerConfig;